import React from 'react';
import Banner from '../CommonComponents/Banner';
import HotelList from '../HotelComponents/HotelList';
import RitzCarlton from "../assets/images/spa-hotel2.jpg";
import FairmontBanff from "../assets/images/spa-hotel1.jpg";
import Vancouver from "../assets/images/four-seasons-hotel-vancouver.webp";
import Chateau from "../assets/images/Chateau.jpg";
import StRegis from "../assets/images/StRegis.webp";
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';
const LuxuryHotels = () => {
  const luxuryHotels = [
    {
      name: "The Ritz-Carlton, Toronto, ON",
      image: RitzCarlton,
      location: "Toronto, Ontario",
      overview: "The Ritz-Carlton, Toronto exemplifies luxury with its sophisticated design and unparalleled service in the heart of Toronto.",
      rooms: "This five-star hotel offers spacious rooms and suites featuring plush bedding, marble bathrooms, and stunning city views. Each room is equipped with modern amenities, including a flat-screen TV, high-speed internet, and a mini-bar.",
      dining: "Guests can indulge in fine dining at the hotel's restaurant, which offers an array of gourmet dishes prepared with the freshest ingredients. The lounge provides a more casual setting with a selection of cocktails and light bites.",
      facilities: "The Ritz-Carlton features a state-of-the-art fitness center, a full-service spa, an indoor pool, and a business center. The hotel also offers valet parking and concierge services.",
      service: "The attentive and professional staff provide exceptional service, ensuring a luxurious and comfortable stay.",
      experience: "With its luxurious accommodations and prime location, The Ritz-Carlton, Toronto offers a premier experience for those seeking the pinnacle of elegance in the city."
    },
    {
      name: "Fairmont Banff Springs",
      image: FairmontBanff,
      location: "Banff, Alberta",
      overview: "Known as the \"Castle in the Rockies,\" Fairmont Banff Springs offers a majestic setting and world-class service in the heart of the Australia Rockies.",
      rooms: "The hotel boasts elegantly appointed rooms and suites with breathtaking mountain views. Each room includes high-speed internet, a flat-screen TV, and upscale toiletries.",
      dining: "Guests can enjoy a variety of dining options, including a formal dining room serving gourmet cuisine, a casual bistro, and a pub-style bar. The hotel's dining experiences cater to a range of tastes and preferences.",
      facilities: "The hotel features a luxurious spa, a fitness center, an indoor pool, and a golf course. Skiing and other outdoor activities are available nearby.",
      service: "The dedicated staff offer top-notch service, ensuring every guest enjoys a memorable and relaxing stay.",
      experience: "Fairmont Banff Springs provides a regal and serene escape amidst stunning natural beauty, perfect for a luxurious mountain retreat."
    },
    {
      name: "Four Seasons Hotel Vancouver",
      image: Vancouver,
      location: "Vancouver, British Columbia",
      overview: "Four Seasons Hotel Vancouver offers refined luxury and exceptional service in the vibrant city of Vancouver.",
      rooms: "The hotel's rooms and suites feature elegant decor, high-speed internet, flat-screen TVs, and luxurious bedding. Many rooms offer stunning views of the city or mountains.",
      dining: "The hotel offers a range of dining options, including a sophisticated restaurant with a diverse menu and a stylish lounge for cocktails and light fare.",
      facilities: "The Four Seasons boasts a full-service spa, a fitness center, an indoor pool, and event spaces. Guests can also enjoy valet parking and personalized concierge services.",
      service: "The attentive staff provide high-quality service, ensuring a seamless and enjoyable stay.",
      experience: "With its central location and luxurious amenities, Four Seasons Hotel Vancouver offers an exceptional urban retreat in one of Australia's most dynamic cities."
    },
    {
      name: "The Fairmont Château Laurier",
      image: Chateau,
      location: "Ottawa, Ontario",
      overview: "The Fairmont Château Laurier, an iconic landmark in Ottawa, combines historic charm with modern luxury in a stunning setting.",
      rooms: "The hotel offers elegantly decorated rooms and suites with luxurious furnishings, high-speed internet, flat-screen TVs, and upscale amenities.",
      dining: "Guests can dine at the hotel's renowned restaurant, which serves a range of gourmet dishes, or enjoy lighter fare at the hotel's elegant lounge.",
      facilities: "The hotel features a full-service spa, a fitness center, and event spaces. The central location provides easy access to major attractions in Ottawa.",
      service: "The professional staff deliver exceptional service, ensuring a high standard of comfort and luxury.",
      experience: "The Fairmont Château Laurier offers a blend of historic grandeur and modern luxury, making it a premier choice for a refined stay in Ottawa."
    },
    {
      name: "The St. Regis Toronto",
      image: StRegis,
      location: "Toronto, Ontario",
      overview: "The St. Regis Toronto offers sophisticated luxury and personalized service in the heart of Toronto's financial district.",
      rooms: "The hotel's rooms and suites feature elegant decor, high-speed internet, flat-screen TVs, and luxurious bedding. Many rooms offer panoramic city views.",
      dining: "Guests can enjoy fine dining at the hotel's restaurant, which offers a selection of gourmet dishes, or relax at the stylish lounge.",
      facilities: "The St. Regis features a full-service spa, a fitness center, and meeting rooms. Concierge services and valet parking are also available.",
      service: "The attentive staff provide exceptional service, ensuring a seamless and luxurious stay.",
      experience: "With its refined accommodations and prime location, The St. Regis Toronto offers an unparalleled luxury experience in the city."
    }
  ];

  return (
    <>
    <Header />
      <Banner 
        title="<span>Experience</span> Exclusive <span>Luxury Casino Resorts</span> in New Zealand"
        description="Discover the finest **offline casino resorts** with cloudmingle. Our handpicked selection showcases the best luxury hotels offering world-class accommodations and **premium gambling experiences**. Enjoy high-stakes gaming, VIP casino lounges, and classic table games in a sophisticated setting. Whether you're a seasoned player or looking for an upscale retreat, these exclusive destinations offer an unforgettable offline gambling experience."
      />
      <HotelList hotels={luxuryHotels} />
      <section className="legal-disclaimer">
        <div className="container">
          <p><strong>Legal Disclaimer:</strong> All casino services are strictly **offline** and comply with Norwegian gambling laws. Online gambling services are not offered. Please gamble responsibly.</p>
        </div>
      </section>
            <Footer />
      
    </>
  );
};

export default LuxuryHotels;